<template>
  <div>
    <com-dialog :visible.sync="visible" title="绑定设备">
      <div>
        <div class="flex items-center">
          <div class="w-100px">二维码:</div>
          <el-input v-model="form.label"></el-input>
        </div>
        <div class="flex mt-15px items-center" v-if="type === 'old'">
          <div class="w-100px">设备编号:</div>
          <el-input v-model="form.sn"></el-input>
        </div>
        <div class="flex mt-20px justify-end">
          <el-button @click="close">取消</el-button>
          <el-button type="primary" @click="handleSubmit">确定</el-button>
        </div>
      </div>
    </com-dialog>
  </div>
</template>

<script>
import { bindEquApi, bindNewEquApi } from '@/api/site'
import utils from 'my-tools-library'

export default {
  data() {
    return {
      visible: false,
      form: {
        label: '',
        sn: '',
        refStore: ''
      },
      type: null
    }
  },
  methods: {
    open(val) {
      console.log('open :>> ', val)
      this.visible = true
      this.form.refStore = val.refStore
      this.type = val.type
    },
    close() {
      this.visible = false
    },
    handleSubmit() {
      if (this.type === 'new') {
        bindNewEquApi(utils.cleanObject(this.form)).then((res) => {
          const { status, desc } = res
          if (status === 200) {
            this.$message.success(desc)
            this.$emit('success')
            this.close()
            console.log('绑定设备 :>> ', res)
          }
        })
        return
      }
      bindEquApi(utils.cleanObject(this.form)).then((res) => {
        const { status, desc } = res
        if (status === 200) {
          this.$message.success(desc)
          this.$emit('success')
          this.close()
          console.log('绑定设备 :>> ', res)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
